<template>
  <div class="row">
    <div class="col-md-6">
      <label>Peso</label>
      <input
        type="text"
        v-model="weight"
        class="form-control"
        @input="handleWeight"
      />
    </div>

    <div class="col-md-6">
      <label>Altura</label>
      <input
        type="text"
        v-model="height"
        class="form-control"
        @input="handleHeight"
      />
    </div>

    <div class="col-md-12">
      <div class="p-2" :style="{ backgroundColor: imc.cor }">
        <p
          :class="[
            'm-0',
            ['white', 'yellow'].includes(imc.cor) ? 'c-black' : 'c-white',
          ]"
        >
          <strong>IMC:</strong> {{ imc.imc }}
        </p>
        <p
          :class="[
            'm-0',
            ['white', 'yellow'].includes(imc.cor) ? 'c-black' : 'c-white',
          ]"
        >
          <strong>Classificação:</strong> {{ imc.classificacao }}
        </p>
      </div>
    </div>

    <div class="col-md-12 pt-0 pb-0">
      <ErrorsMessages :errors="errors" />
    </div>

    <div class="col-md-12 check-text-right">
      <confirmation-dialog
        headerClass="modal-header"
        message-title="SALVAR?"
        :message-body="`Deseja realmente salvar?`"
        open-text="SALVAR"
        open-class="btn-modern btn-modern-add"
        open-left-icon="fa-check"
        @yes="create()"
        :loading="loading"
        :disabled="loading"
      />
    </div>
  </div>
</template>

<script>
import ConfirmationDialog from "../Components/ConfirmationDialog";

import ErrorsMessages from "../Components/ErrorsMessages";

import api from "../../services/api";

import toast from "../../lib/ToastNotification";

import { formatValueOnKeyUp } from "../../lib/format";

export default {
  name: "Create",

  components: {
    ConfirmationDialog,
    ErrorsMessages,
  },

  props: {
    resident_id: [String, Number],
    type: [String, Number],
  },

  data() {
    return {
      imc: {
        imc: 0,
        classificacao: "Não identificado",
        cor: "white",
        alturaUsada: 0,
      },
      weight: "",
      height: "",
      loading: false,
      errors: [],
    };
  },

  methods: {
    normalizarAltura(height) {
      const valor = parseFloat(String(height).replace(",", "."));
      if (isNaN(valor)) return null;
      return valor >= 3 ? valor / 100 : valor;
    },

    isNumeroValido(valor) {
      const numero = parseFloat(String(valor).replace(",", "."));
      return !isNaN(numero) && isFinite(numero) && numero > 0;
    },

    handleIMC() {
      try {
        let { weight, height } = this;

        weight = String(weight)
          .replace(".", "")
          .replace(".", "")
          .replace(".", "")
          .replace(",", ".");

        height = String(height)
          .replace(".", "")
          .replace(".", "")
          .replace(".", "")
          .replace(",", ".");

        // --- Validação ---
        if (!this.isNumeroValido(weight)) {
          this.imc = {
            imc: 0,
            classificacao: "Não identificado",
            cor: "white",
            alturaUsada: 0,
          };
          return;
        }

        if (!this.isNumeroValido(height)) {
          this.imc = {
            imc: 0,
            classificacao: "Não identificado",
            cor: "white",
            alturaUsada: 0,
          };
          return;
        }

        const peso = parseFloat(weight);
        const alturaMetros = parseFloat(height);

        if (alturaMetros < 0.5 || alturaMetros > 2.5) {
          this.imc = {
            imc: 0,
            classificacao: "Não identificado",
            cor: "white",
            alturaUsada: 0,
          };
          return;
        }

        if (peso < 1 || peso > 500) {
          this.imc = {
            imc: 0,
            classificacao: "Não identificado",
            cor: "white",
            alturaUsada: 0,
          };
          return;
        }

        // --- Cálculo ---
        const imc = peso / (alturaMetros * alturaMetros);
        const imcFormatado = parseFloat(imc.toFixed(2));

        // --- Classificação OMS ---
        let classificacao, cor;

        if (imc < 18.5) {
          classificacao = "Abaixo do peso";
          cor = "blue";
        } else if (imc < 25) {
          classificacao = "Peso normal";
          cor = "green";
        } else if (imc < 30) {
          classificacao = "Sobrepeso";
          cor = "yellow";
        } else if (imc < 35) {
          classificacao = "Obesidade grau I";
          cor = "orange";
        } else if (imc < 40) {
          classificacao = "Obesidade grau II";
          cor = "red";
        } else {
          classificacao = "Obesidade grau III";
          cor = "darkred";
        }

        this.imc = {
          imc: imcFormatado,
          classificacao,
          cor,
          alturaUsada: `${alturaMetros.toFixed(2)}m`, // útil para debug/exibição
        };
      } catch (error) {
        this.imc = {
          imc: 0,
          classificacao: "Não identificado",
          cor: "white",
          alturaUsada: 0,
        };
      }
    },

    handleWeight: function (e) {
      this.weight = formatValueOnKeyUp(e.target.value);
      this.handleIMC();
    },

    handleHeight: function (e) {
      this.height = formatValueOnKeyUp(e.target.value);
      this.handleIMC();
    },

    async create() {
      try {
        this.loading = true;

        const { resident_id, weight, height, imc } = this;

        let params = {
          resident_id,
          weight,
          height,
          imc,
        };

        const response = await api.post("/rest-home/imc", params);

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");
          this.$bvModal.hide("modalCreate");
          this.$emit("success");
          this.weight = "";
          this.height = "";
          this.errors = [];
        } else {
          this.errors = errors;
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>